export enum ReportTypes {
  EcgList = "EcgList",
  ProUsers = "ProUsers",
  NonProUsers = "NonProUsers",
}

export enum ApiReportTypesToReportTypes {
  EcgListEntity = "EcgList",
  EcgListStudy = "EcgList",
  EcgListUser = "EcgList",
  ProUsers = "ProUsers",
  NonProUsers = "NonProUsers",
}

export enum IntlReportTypes {
  EcgList = "REPORT.ECG_LIST",
  ProUsers = "REPORT.PRO_USERS_LIST",
  NonProUsers = "REPORT.NON_PRO_USERS_LIST",
}

export type ReportTypesResponse = {
  key: ReportTypes;
  value: string;
};
